'use client'

import type { ElementType, MouseEventHandler, ReactNode } from 'react'
import { createElement } from 'react'
import { cx } from './utils/cx'

interface NavItemProps {
  on?: boolean
  onClick?: MouseEventHandler
  href?: string
  children?: ReactNode
  className?: string
  as?: ElementType
}

export function NavItem({ on, onClick, href, children, className, as }: NavItemProps) {
  const Tag: ElementType = as || (href ? 'a' : 'button')
  return createElement(
    Tag,
    {
      href,
      onClick,
      className: cx('st-nav-item', on && 'on', className)
    },
    children
  )
}
